const validWording = "Please enter valid "
const pleaseEnterWording = "Please enter "

//Common
export const futureTimeErrorMsg = "Future time is not allowed"

//PolicyInformation
export const policyNumber = pleaseEnterWording + "8 character policy number"
export const hdbReferenceNo = validWording + "Certificate Number"
export const claimantName = pleaseEnterWording + "name of Insured"
export const claimantNricNumber = validWording + "NRIC"
export const residentialAddress = validWording + "Address"
export const postalCode = validWording + "Postal Code"
export const claimantEmail = validWording + "Email Address"
export const claimantMobile = validWording + "Mobile Number"
export const unitNo = validWording + "Unit No."
export const age = validWording + "present age"

//Page 3 - The Loss or Damage
// export const timeLastSeen = validWording + "Property was last seen"
export const dateFirstDiscoveryEarlierThanLastSeenDate =
  "Date of first discovery cannot be earlier than last seen date"
export const dateDiscovery = pleaseEnterWording + "Date of first discovery of loss or damage"
export const lossDetail = pleaseEnterWording + "the full circumstances of loss or damage"
export const ownerName = validWording + "Name of the Owner"
export const ownerAddress = validWording + "Address of the Owner"
export const financeName = validWording + "Name of finance or lending company"
export const otherInsuranceName = validWording + "Name of insurance company"
export const claimInsuranceName = validWording + "name"
export const claimInsuranceDate = validWording + "date"
export const claimInsuranceDetail = validWording + "nature of loss"
export const claimInsuranceAmount = validWording + "amount paid"

// Payout Instruction
export const bankName = validWording + "Name of Bank and Branch"
export const accountNumber = validWording + "Bank Account Number"
export const accountName = validWording + "Name of Account Holder"
